import React, { useState } from 'react';
import Dropdown, { DropdownOption } from '../Drowpdown/dropdown'; // Adjust path as needed
import { ImSpinner2 } from 'react-icons/im';

interface DeveloperSettingsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (settings: { compressionEnabled: string; batchSize: string }) => void;
}

const batchSizeOptions: DropdownOption[] = [
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '5', label: '5' },
    { value: '10', label: '10' },
];

const DeveloperSettingsModal: React.FC<DeveloperSettingsModalProps> = ({ isOpen, onClose, onConfirm }) => {
    const [compressionEnabled, setCompressionEnabled] = useState<string>(localStorage.getItem('compressionEnabled') || 'yes');
    const [batchSize, setBatchSize] = useState<string>(localStorage.getItem('batchSize') || '5');
    const [isSaving, setIsSaving] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        setIsSaving(true);
        await onConfirm({ compressionEnabled, batchSize });
        setIsSaving(false);
    };

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-xl font-semibold mb-6 text-center text-gray-800">Developer Settings</h2>

                <div className="mb-5">
                    <label className="block text-sm font-medium mb-2 text-gray-700">
                        Enable Image Compression?
                    </label>
                    <div className="flex items-center space-x-4">
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                className="form-radio text-primary focus:ring-primary"
                                name="compression"
                                value="yes"
                                checked={compressionEnabled === 'yes'}
                                onChange={(e) => setCompressionEnabled(e.target.value)}
                            />
                            <span className="ml-2 text-gray-700">Yes</span>
                        </label>
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                className="form-radio text-primary focus:ring-primary"
                                name="compression"
                                value="no"
                                checked={compressionEnabled === 'no'}
                                onChange={(e) => setCompressionEnabled(e.target.value)}
                            />
                            <span className="ml-2 text-gray-700">No</span>
                        </label>
                    </div>
                </div>

                <div className="mb-8">
                    <label htmlFor="batchSize" className="block text-sm font-medium mb-2 text-gray-700">
                        Select Batch Size for Uploads
                    </label>
                    <Dropdown
                        options={batchSizeOptions}
                        isSearchable={false}
                        placeholder="Select Batch Size"
                        onSelect={(option) => setBatchSize(option.value)}
                        value={batchSize}
                    />
                </div>

                <div className="flex flex-col space-y-3">
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full px-4 py-3 text-white bg-primary rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light flex items-center justify-center shadow-md"
                        disabled={isSaving}
                    >
                        {isSaving ? <ImSpinner2 className="animate-spin mr-2" /> : 'Save and Continue'}
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="w-full px-4 py-3 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 shadow-md"
                        disabled={isSaving}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeveloperSettingsModal;